var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM17 2V5H2V2H17ZM12 16H7V7H12V16ZM2 7H5V16H2V7ZM14 16V7H17V16H14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOverview);
export default __webpack_public_path__ + "static/media/nav-overview.26fda1f525b833c843699597619a15b0.svg";
export { ForwardRef as ReactComponent };